query CompanyCorporatePeriods(
  $filter: CompanyCorporatePeriodFilter
  $orderBy: [CompanyCorporatePeriodsOrderBy!]
) {
  companyCorporatePeriods(filter: $filter, orderBy: $orderBy) {
    nodes {
      isEntryAllowed
      id
      _periodYear
      startDate
      endDate
    }
  }
}
